import { useCallback } from "react";
import { useCreateAgentDocumentSearchSessionMutation } from "../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../auth/useLoggedInWithOrgContextState";

export const useAgentSession = () => {
  const [createDocSearchSession] = useCreateAgentDocumentSearchSessionMutation();
  const authState = useLoggedInWithOrgContextState();

  const fetchDocSearchToken = useCallback(async () => {
    const result = await createDocSearchSession({
      organizationId: authState.selectedOrg.id,
      personId: authState.me.id,
    }).unwrap();
    return { clientToken: result.clientToken };
  }, [createDocSearchSession, authState.selectedOrg.id, authState.me.id]);

  return { fetchDocSearchToken };
};
